import { useEffect, useState } from "react";
import { StudentLayout } from "@/components/Layouts";
import { ModuleCard } from "@/components/ModuleCard";
import { EmptyState } from "@/components/EmptyState";
import { BookOpen } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function StudentModules() {
  const { refreshUser } = useAuth();
  const [modules, setModules] = useState([]);

  const load = () => api.get("/modules").then((r) => setModules(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleToggle = async (mod) => {
    try {
      if (mod.completed) {
        await api.post(`/modules/${mod.id}/uncomplete`);
      } else {
        await api.post(`/modules/${mod.id}/complete`);
      }
      await load();
      await refreshUser();
      toast.success("Module status updated.");
    } catch {
      toast.error("Gagal kemas kini.");
    }
  };

  return (
    <StudentLayout title="Learning Modules">
      <div className="mb-5">
        <h1 className="text-3xl font-heading font-bold tracking-tight">Learning Modules</h1>
        <p className="mt-2 text-muted-foreground">
          Follow modules SC101 to SC106 in the order provided.
        </p>
      </div>
      {modules.length === 0 ? (
        <EmptyState icon={BookOpen} title="No modules" description="This module's content is not yet available. Please check again later." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {modules.map((m) => <ModuleCard key={m.id} module={m} onToggleComplete={handleToggle} />)}
        </div>
      )}
    </StudentLayout>
  );
}
